import { Form } from 'react-bootstrap';

import { FISCAL_PERIOD_PRESETS, type FiscalPeriodConfig } from 'utils/fiscalPeriods';

interface Props {
  readonly presetId: string;
  readonly onChange: (next: FiscalPeriodConfig) => void;
}

/** Dropdown to seed the editor from a common fiscal-calendar preset. */
export const PresetSelector = ({ presetId, onChange }: Props) => (
  <Form.Group className="mb-4" controlId="fiscal-preset">
    <Form.Label>Start from a common calendar</Form.Label>
    <Form.Select
      value={presetId}
      onChange={(e) => {
        const preset = FISCAL_PERIOD_PRESETS.find((p) => p.id === e.target.value);
        if (preset) onChange(preset.config);
      }}
    >
      <option value="">Custom — edit the fields below</option>
      {FISCAL_PERIOD_PRESETS.map((p) => (
        <option key={p.id} value={p.id}>
          {p.label}
        </option>
      ))}
    </Form.Select>
    {presetId ? (
      <Form.Text className="text-muted">{FISCAL_PERIOD_PRESETS.find((p) => p.id === presetId)?.description}</Form.Text>
    ) : (
      <Form.Text className="text-muted">Presets fill every field. Change anything afterwards and this becomes a custom calendar.</Form.Text>
    )}
  </Form.Group>
);
